import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import App from './App.tsx';
import './index.css';
import { initI18nClient } from './i18n';
import { resolveInitialLanguage } from './i18n/utils';

const initialLanguage = resolveInitialLanguage(
  typeof window !== 'undefined' ? window.location.pathname : '/'
);
const i18n = initI18nClient(initialLanguage);

createRoot(document.getElementById('root')!).render(
  <I18nextProvider i18n={i18n}>
    <App />
  </I18nextProvider>
);
